module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/murin2-d66f5205db092eadb99cf78454698675.jpg";